<mode-cartesian-builder-common
  [encoding]="encoding"
  [observables]="observables"
  [chartService]="chartService"
  [model]="model"
  [isExploring]="isExploring"
  [chartType]="chartType"
></mode-cartesian-builder-common>
